import {
    IonApp,
    setupIonicReact
  } from '@ionic/react';
  import { IonReactRouter } from '@ionic/react-router';
  import { Route } from 'react-router-dom';
  import Login from './pages/Login';
  import { UNIFORM_RESOURCE_LOCATORS } from './utils/constants';

  /* Core CSS required for Ionic components to work properly */
  import '@ionic/react/css/core.css';

  /* Basic CSS for apps built with Ionic */
  import '@ionic/react/css/normalize.css';
  import '@ionic/react/css/structure.css';
  import '@ionic/react/css/typography.css';

  /* Optional CSS utils that can be commented out */
  import '@ionic/react/css/padding.css';
  import '@ionic/react/css/float-elements.css';
  import '@ionic/react/css/text-alignment.css';
  import '@ionic/react/css/text-transformation.css';
  import '@ionic/react/css/flex-utils.css';
  import '@ionic/react/css/display.css';

  /* Theme variables */
  import './theme/variables.css';
  import './theme/wizard.css';
  import './theme/mpesaForm.css';
  import './theme/bankStatement.css';

  /* Bootstrap */
  import 'bootstrap/dist/css/bootstrap.min.css';
  import 'react-bootstrap-typeahead/css/Typeahead.css';


  import './theme/globals.css';
import SplitPlane from './navigation/SplitPlane';
import NotificationHandler from './components/NotificationHandler';

  setupIonicReact();

  const App = () => {
    return (
      <IonApp>
        <IonReactRouter>
            <NotificationHandler />
            <Route path={UNIFORM_RESOURCE_LOCATORS.appLogin} exact={true}>
              <Login />
            </Route>
            <SplitPlane />

        </IonReactRouter>
      </IonApp>
    );
  };

  export default App;
